import React from 'react'
import { useAuth } from '../../auth/AuthContext'
import InventoryPicker from '../InventoryPicker'
import SitesFacesAdmin from './SitesFacesAdmin'
import { cardClass } from './ui'

export default function InventoryPage() {
  const { isAdmin, user } = useAuth()
  const venueUid = user?.userType === 'venue' ? user.venueUid : undefined

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Inventory</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Sites are venues. Faces are the bookable screens on each site.
        </p>
      </div>
      <div className={`${cardClass} p-6`}>
        <InventoryPicker
          mode="browse"
          venueUid={venueUid}
          title="Sites and faces"
          subtitle="Live Control display units grouped by venue"
        />
      </div>
      {isAdmin && <SitesFacesAdmin />}
    </div>
  )
}
